// extracted by mini-css-extract-plugin
export default {"box":"Privacy_box__eykKM"};